<template>
    <v-snackbar
        v-model="showWarning"
        :timeout="-1" 
        fixed
        location="top"
        color="#fff8ea"
        class="browser-warning"
    >
        <span class="text-black">
            <i18n-t keypath="loginScreen.chromeWarning" tag="span">
                <template #browser><strong>Google Chrome</strong></template>
            </i18n-t>
        </span>
        
        <template #actions="{ attrs }">
            <v-btn 
                v-bind="attrs" 
                href="https://www.google.com/chrome/" 
                target="_blank" 
                class="text-black"
                variant="text"
                @click="dismissWarning"
            >
                {{ $t('loginScreen.downloadChrome') }}
            </v-btn>
            <v-btn 
                v-bind="attrs" 
                class="text-black" 
                variant="text"
                @click="dismissWarning"
            >
                {{ $t('loginScreen.dismiss') }}
            </v-btn>
        </template>
    </v-snackbar>
</template>
  
<script>
    export default {
        data() {
            return {
                showWarning: false
            };
        },
        mounted() {
            this.checkBrowser();
        },
        methods: {
            checkBrowser() {
                const userAgent = navigator.userAgent;
                const dismissed = localStorage.getItem("browserWarningDismissed");

                // Show warning only if user hasn't dismissed it and is NOT using Chrome (excluding Edge & Opera)
                if (!dismissed && (!userAgent.includes("Chrome") || userAgent.includes("Edg") || userAgent.includes("OPR"))) {
                    this.showWarning = true;
                }
            },
            dismissWarning() {
                this.showWarning = false;
                localStorage.setItem("browserWarningDismissed", "true");
            }
        }
    };
</script>
<style scoped>
.browser-warning {
    z-index: 9999 !important;
}
</style>
  